import axios from 'axios'

const ForgotPasswordReset = ( mail, authToken ) => {
    let formData = new FormData();
    formData.append('mail', mail);
    formData.append('authenticityToken', authToken);

    return axios({
        method: 'post',
        url: '/applyForgotPasswordPOST',
        data: formData,
        config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
}

export default ForgotPasswordReset